import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import IRegion from '../types/Region';
import DeleteButton from '../../../components/common/DeleteButton';

interface RegionListRowProps {
    region: any;
    key: number;
    onEdit: (value: IRegion) => void;
    onDelete: (value: IRegion) => void;
}

const RegionListRow = (props: RegionListRowProps) => {
    return (
        <tr>
            <td>{props.region.name}</td>
            <td>
                <i className="material-icons">{props.region.isDiscontinued ? 'done' : ''}</i>
            </td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <DeleteButton
                        onDelete={() => props.onDelete(props.region)}
                        text={Translate('regions/list/row/delete/remove-this-region')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('regions/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button onClick={() => props.onEdit(props.region)} bsStyle="primary">
                        <i className="material-icons">edit</i>{' '}
                        {Translate('regions/list/row/button-label/edit')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default RegionListRow;
